import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useDocumentMeta } from "../lib/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({
    title: "404 · Off the Map · ForgedOps",
    description:
      "This page isn't on the plans. The route you're looking for doesn't exist or has been moved. Return to the ForgedOps operational command center.",
    path: "/404",
    type: "website",
  });

  // 404 routes must not be indexed. Inject robots noindex tag and restore on unmount.
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    const prev = el ? el.getAttribute("content") : null;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
    return () => {
      if (prev === null) {
        el?.parentNode?.removeChild(el);
      } else {
        el?.setAttribute("content", prev);
      }
    };
  }, []);

  return (
    <div
      data-testid="not-found-page"
      className="min-h-[70vh] flex items-center justify-center py-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col items-start gap-6">
        <span className="font-display uppercase tracking-[0.35em] text-xs text-zinc-500">
          404 · Off the map
        </span>
        <h1 className="font-display uppercase text-6xl md:text-8xl font-black tracking-tight leading-[0.9]">
          This Page Isn't
          <br />
          <span className="metallic-text">On the Plans.</span>
        </h1>
        <p className="text-zinc-400 max-w-xl">
          The page you're looking for doesn't exist or has been moved. Let's
          get you back to solid ground.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="group inline-flex items-center gap-3 px-6 py-3 border border-zinc-700 font-display uppercase tracking-[0.2em] text-[12px] font-semibold hover:bg-zinc-100 hover:text-black hover:border-white transition-all duration-300"
        >
          <ArrowLeft size={14} /> Back to Home
        </Link>
      </div>
    </div>
  );
}

